import React from 'react';
import Color from '../domain/Color';
import { t, props } from 'tcomb-react';

@props({
  children: t.Any,
  bgColor: t.maybe(Color),
  fontColor: t.maybe(Color)
})
export default class Message extends React.Component {

  getStyle() {
    if (!this.props.bgColor) {
      return null;
    }
    return {
      backgroundColor: this.props.bgColor,
      color: this.props.fontColor
    };
  }

  getTriangleStyle() {
    if (!this.props.bgColor) {
      return null;
    }
    return {
      borderTopColor: this.props.bgColor
    };
  }

  render() {
    return (
      <div className="message box title" style={this.getStyle()}>
        { this.props.children }
        <div className="triangle-down" style={this.getTriangleStyle()}></div>
      </div>
    );
  }
}




/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/components/Message.js
 **/